import React from "react"
import ProgressBanner from "../../components/Banner/ProgressBanner"
import { StepContainer } from "../../components/Steps/StepContainer"
import { useStepHandler } from "../../hooks/useStepHandler"

const Pages = ({ webhookUrl }: { webhookUrl: string }) => {
    const {
        stepState,
        displayState,
        formState,
        handleNext,
        handlePrev,
        setFormValue,
        updateUserResume,
        setDisplayValue,
        isBlocking
    } = useStepHandler();
    return (
        <div>
            <ProgressBanner currentStep={stepState.currentStep.currentStep} />
            <StepContainer
                stepState={stepState}
                displayState={displayState}
                formState={formState}
                stepBoolean={stepState.stepStatus}
                handleNext={handleNext}
                handlePrev={handlePrev}
                setFormValue={setFormValue}
                updateUserResume={updateUserResume}
                setDisplayValue={setDisplayValue}
                webhook={webhookUrl}
                isBlocking={isBlocking}
            />
        </div>
    )
}

export default Pages
